import React from 'react';
import { SvgIconProps, SvgIcon } from '@material-ui/core';

export const SaleOutlinedIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path fillRule="evenodd" d="M11 2c.55 0 1.05.22 1.41.58l9 9c.36.36.59.87.59 1.42 0 .55-.22 1.05-.59 1.41l-7 7c-.36.37-.86.59-1.41.59-.55 0-1.05-.22-1.41-.58l-9-9C2.22 12.05 2 11.55 2 11V4c0-1.1.9-2 2-2zm0 1.99V4H4v7l9 9.01 7-7.02-9-9zM6.5 5a1.5 1.5 0 1 1 .001 2.999A1.5 1.5 0 0 1 6.5 5z" />
  </SvgIcon>
);
